import { render, staticRenderFns } from "./jhz.vue?vue&type=template&id=2e47b190&scoped=true&"
import script from "./jhz.vue?vue&type=script&lang=js&"
export * from "./jhz.vue?vue&type=script&lang=js&"
import style0 from "./jhz.vue?vue&type=style&index=0&id=2e47b190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e47b190",
  null
  
)

export default component.exports